<template>
  <v-row>
    <v-col class="px-0">
      <v-card height="500" style="overflow: hidden">
        <v-card-title> Banner do sorteio </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6" class="banner-image-action pa-3">
              <mf-image-cropper
                :mb-size-limit="10"
                :disabled="isDisabled"
                :upload-image="modifyImg"
                :error-message="validations.raffle.banner_url.$error ? 'Você deve selecionar uma imagem para o banner' : ''"
                :url="raffle.banner_url"
                :width="355"
                :height="140"
                show-hint
                @remove-image="deleteBanner"
                @snackbar="showSnackbar"
              />
            </v-col>
            <v-col cols="6">
              <app-banner-preview :hasBanner="hasBanner" :bannerUrl="raffle.banner_url" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import { preventNumberEvents } from '../../helpers'

export default {
  name: 'BannerRow',
  components: {
    AppBannerPreview: () => import('@/components/AppBannerPreview.vue'),
  },
  props: {
    validations: {
      type: Object,
      default: () => {},
    },
    isDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    raffleValue: {
      type: [String, Number],
      required: true,
    },
  },
  data: () => ({
    imageUploaded: false,
  }),
  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
    }),
    hasBanner() {
      return this.raffle.banner_url !== ''
    },
    localRaffleValue: {
      get() {
        return this.raffleValue
      },
      set(value) {
        this.$emit('update:raffle-value', value)
      },
    },
  },
  methods: {
    showSnackbar(snackbar) {
      this.$snackbar(snackbar)
    },
    preventDefault(event, type) {
      return preventNumberEvents(event, type)
    },
    deleteBanner() {
      this.raffle.banner_url = ''
      this.imageUploaded = false
    },
    async modifyImg({ base64, filename }) {
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: {
            filename,
            base64,
          },
          context: {
            uri: this.$microservicesUrls['upload'],
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.imageUploaded = true
          this.raffle.banner_url = url
        })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  margin: 0;
}
.file-chip {
  word-break: break-all;
}
.banner-image-action {
  margin-top: 180px;
}
</style>
